export default __webpack_public_path__ + "static/media/bg-3.3e5aad30.jpg";